import { initialCrudModelBaseState, CrudModelPaginatorLaboratory } from '@/shared/models/cruds.models'
import { configurationSynopticTemplateService } from '@/modules/configurationModule/detail/templates/synoptic-templates/services/configuration-synoptic-template/configuration-synoptic-template.service'
import { Nullable } from '@/shared/types/app.types'
import { ConfigurationSynopticTemplateResponse } from '@/modules/configurationModule/detail/templates/synoptic-templates/services/configuration-synoptic-template/configuration-synoptic-template.dto'
import { configurationTemplatesSynopticTemplatesGridColumnDefs } from '@/modules/configurationModule/detail/templates/synoptic-templates/components/grid/configuration-templates-synoptic-templates-grid.column-defs'
import { PaginatorLaboratoryDatasource } from '@/shared/resources/datasources/paginator/paginator-laboratory-datasource'
import { store } from '@/store/store'

export interface ConfigurationTemplatesSynopticTemplatesGridState extends CrudModelPaginatorLaboratory<ConfigurationSynopticTemplateResponse> {
    service: typeof configurationSynopticTemplateService
    laboratoryId: number
    broadcastChannel: Nullable<BroadcastChannel>
}
export const initialConfigurationTemplatesSynopticTemplatesGridState =
    (): ConfigurationTemplatesSynopticTemplatesGridState => ({
        ...initialCrudModelBaseState(),
        gridUiComponent: 'uicomponent.configuration.local.templates.synopticTemplates',
        columnsDef: configurationTemplatesSynopticTemplatesGridColumnDefs(),
        service: configurationSynopticTemplateService,
        laboratoryId: store.getters.labId,
        datasource: new PaginatorLaboratoryDatasource(configurationSynopticTemplateService, store.getters.labId),
        broadcastChannel: null
    })
